export default __webpack_public_path__ + "static/media/217.db54044d.jpg";